import React from 'react';

// a function to retry loading a chunk to avoid chunk load error for out of date code
const lazyWithRetry = (componentImport) =>
  React.lazy(async () => {
    // check if the page or window has already been refreshed else set to "false" by default
    const pageHasAlreadyBeenForceRefreshed = 
      JSON.parse(window.sessionStorage.getItem('pageHasBeenForceRefreshed') || 'false');

    try {
      // try to import the component
      const component = await componentImport();
      window.sessionStorage.setItem('pageHasBeenForceRefreshed', 'false');
      return component;
    } catch (error) {
      if (error.name === 'ChunkLoadError' && !pageHasAlreadyBeenForceRefreshed) {
        window.sessionStorage.setItem('pageHasBeenForceRefreshed', 'true');
        window.location.reload();
      }
      throw error;
    }
  });

// // Usage:
// const Home = lazyWithRetry(() => import('./Home'));

export default lazyWithRetry;